export default "__VITE_ASSET__Bv2zaL5R__"